export default __webpack_public_path__ + "static/media/newOrleansSaintsVideo-2x.81874788.jpg";